import React from 'react';
import PropTypes from 'prop-types';
import LinkList from '../../../molecules/link-list';
import styles from './as-seen-on.module.scss';

const AsSeenOn = ({ asSeenOn, template, width = 130, height = 36 }) => (
  <div
    className={`${styles?.asSeenOn || ''} ${
      template && styles[template] ? styles[template] || '' : ''
    }`}
  >
    <span>As Seen On:</span>
    <LinkList
      showListTitle={false}
      imageOnly
      singleList
      lists={asSeenOn}
      width={width}
      height={height}
      gtmClass="mobile-menu-gtm logo-cta"
    />
  </div>
);

export default AsSeenOn;

AsSeenOn.propTypes = {
  asSeenOn: PropTypes.shape({}),
  template: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
